module.exports = __webpack_public_path__ + "img/appltCourse-img34.5b10c0fa.png";